<div class="modal-header main-modal-header">
    <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="dismissModal()">&times;</button>
    <h4 class="modal-title wrap-text-in" [innerHTML]="actionLabel"></h4>
</div>

<div class="modal-body">
    <div class="row">
        <div class="col-xs-12" *ngIf="actionType === 'updateContact'">
            <app-add-edit-candidate-contact [candidateId]="candidateId"
                (saveCallback)="refresh()" (cancelCallback)="closeModal()">
            </app-add-edit-candidate-contact>
        </div>
        <div class="col-xs-12" *ngIf="actionType === 'addEditDocumentFolder'">
            <app-add-edit-document-folder
                [folder]="folder"
                [folders]="folders"
                [parentFolderName]="parentFolderName"
                (saveCallback)="refresh($event)"
                (cancelCallback)="dismissModal()">
            </app-add-edit-document-folder>
        </div>
        <div class="col-xs-12" *ngIf="actionType==='uploadCandidateDocument'">
            <app-upload-candidate-document
                [document]="document"
                [showUpload]="showUpload"
                [candidateType]="candidateType"
                [allFolders]="allFoldersList"
                [candidateDetails]="candidateDetails"
                [isSharedDocumentActionAvailable]="isSharedDocumentActionAvailable"
                [companiesToShareCandidateDocuments]="companiesToShareCandidateDocuments"
                (saveCallback)="refresh(document)"
                (cancelCallback)="dismissModal()"
                [sourceScreen]="sourceScreen"
                [formalizeActivityPayload]="formalizeActivityPayload">
            </app-upload-candidate-document>
        </div>
        <div class="col-xs-12" *ngIf="actionType==='shareCandidateDocument'">
            <app-upload-candidate-document
                [document]="document"
                [showUpload]="showUpload"
                [candidateType]="candidateType"
                (saveCallback)="refresh(document)"
                (cancelCallback)="dismissModal()"
                [share]="true"
                [allFolders]="allFoldersList"
                [candidateDetails]="candidateDetails"
                [companiesToShareCandidateDocuments]="companiesToShareCandidateDocuments"
                [sourceScreen]="sourceScreen"
                [formalizeActivityPayload]="formalizeActivityPayload">
            </app-upload-candidate-document>
        </div>
        <div class="col-xs-12" *ngIf="actionType==='moveDocumentFolder'">
            <app-move-document-folder
                [folder]="folder"
                [parentFolders]="parentFolders"
                (saveCallback)="refresh(folder)"
                (cancelCallback)="dismissModal()">
            </app-move-document-folder>
        </div>
        <div class="col-xs-12" *ngIf="actionType==='moveDocument'">
            <app-move-document-folder
                [document]="document"
                [parentFolders]="parentFolders"
                [allFolders]="allFoldersList"
                [candidateType]="candidateType"
                [candidateDetails]="candidateDetails"
                (saveCallback)="refresh(document)"
                (cancelCallback)="dismissModal()">
            </app-move-document-folder>
        </div>
        <div class="col-xs-12" *ngIf="actionType==='deleteDocument'">
            <app-delete-candidate-document
                [document]="document"
                [deleteDocumentPayload]="deleteDocumentPayload"
                [candidateDetails]="candidateDetails"
                (saveCallback)="refresh(document)"
                (cancelCallback)="dismissModal()">
            </app-delete-candidate-document>
        </div>
        <div class="col-xs-12" *ngIf="actionType==='emailDocument'">
            <app-email-documents
                [document]="document"
                [documents]="documents"
                [folders]="folders"
                [candidateJobMatchFolders]="candidateJobMatchFolders"
                [candidateDetails]="candidateDetails"
                (saveCallback)="dismissModal()"
                (cancelCallback)="dismissModal()"
                [sourceScreen]="sourceScreen"
                [formalizeActivityPayload]="formalizeActivityPayload">
            </app-email-documents>
        </div>
        <div class="col-xs-12" *ngIf="actionType==='attachDocuments'">
            <app-available-documents
                [availableDocuments]="availableDocuments"
                [attachedDocuments]="documents"
                (onAttachDocuments)="attachDocuments($event.documents)"
                [folders]="folders"
                [candidateJobMatchFolders]="candidateJobMatchFolders"
                [candidateId]="candidateId"
                (saveCallback)="dismissModal()"
                (cancelCallback)="dismissModal()">
            </app-available-documents>
        </div>
        <div class="col-xs-12" *ngIf="actionType==='addEmployee'">
            <app-add-edit-employee [isPopup]="true" (saveCallback)="onEmployeeAdded($event)"></app-add-edit-employee>
        </div>
        <div class="col-xs-12" *ngIf="actionType==='viewDocument'">
            <div class="col-xs-12">
                <object [attr.data]="documentViewUrlWithFit" type="application/pdf" style="width:100%; height:100vh;">
                    <embed [attr.src]="documentViewUrl" type="application/pdf" width="100%" height="500px">
                </object>
            </div>
        </div>
    </div>
</div>
